import { render } from "./modellevelAddtotaskView.vue?vue&type=template&id=50e82f54"
import script from "./modellevelAddtotaskView.vue?vue&type=script&lang=js"
export * from "./modellevelAddtotaskView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__